var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpedited(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.1548 4.39041C7.26629 4.15291 7.51475 4 7.79004 4H13.2801C13.7963 4 14.1329 4.51404 13.9016 4.9513L12.8474 7.90411H14.6511C15.2705 7.90411 15.5802 8.61206 15.1425 9.02589L7.51885 17C6.99991 17.4906 6.13548 16.9857 6.36811 16.3278L7.51888 11.1575H5.34744C5.23164 11.1575 5.11768 11.1302 5.0159 11.078C4.91412 11.0257 4.82776 10.9503 4.76465 10.8585C4.70154 10.7667 4.66368 10.6615 4.65452 10.5523C4.64536 10.4432 4.66519 10.3336 4.71219 10.2336L7.1548 4.39041Z",
    fill: "#FBA12B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpedited);
export default __webpack_public_path__ + "static/media/expedited.9644e8edec645ed7797dd00246030379.svg";
export { ForwardRef as ReactComponent };